<template>
  <div class="header checkout-header">
    <div class="main-bar">
      <div class="container">
        <a
          class="logo"
          href="/"
        >
          <f-sprite-icon :icon-link="$options.icons.IconLogo.id" />
        </a>

        <vue-client-only>
          <div
            v-if="adaptive.isDesktop"
            class="city"
          >
            <div
              class="current"
              @click="$city.isCityHeaderShown = !$city.isCityHeaderShown"
            >
              {{ CITY.name }}
              <chevron-animated :reverse="$city.isCityHeaderShown" />
            </div>
            <div class="search">
              <ui-dropdown
                left
                @on-close="$city.isCityHeaderShown = false"
                :visible="$city.isCityHeaderShown"
              >
                <city-search @choose="changeCity" />
              </ui-dropdown>
            </div>
          </div>
        </vue-client-only>

        <div class="phone">
          <a href="tel:+78007700101">
            8 800 770 01 01
          </a>
          <span>Мы принимаем звонки c 7:00 до 22:00 (мск)</span>
        </div>

        <div class="icons">
          <control-user
            v-if="!isSomeCsmMode"
          />
          <control-favorites
            class="icon"
            v-if="!isSomeCsmMode"
          />
        </div>
      </div>
    </div>
    <nav-bar />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueClientOnly from 'vue-client-only';
/* Components */
import NavBar from '@/components/header/nav-bar.vue';
import CitySearch from '../header/city-search';
import ControlUser from '@/components/header/control-user';
import ControlFavorites from '@/components/header/control-favorites';

/* Icons */
import ChevronAnimated from '@icons/chevron-animated';
import IconLogo from '@images/logo.multi.svg';

import { isCsmAddProduct, isCsmCreateBasket } from '@/utils/csm-cookies';

export default {
  name: 'checkout-header',

  components: {
    NavBar,
    CitySearch,
    ChevronAnimated,
    ControlUser,
    ControlFavorites,
    VueClientOnly,
  },

  inject: ['adaptive'],

  icons: {
    IconLogo,
  },

  computed: {
    ...mapGetters({ // временно, заглушка
      CITY: 'user/city',
      ACCOUNT: 'user/account',
    }),

    isSomeCsmMode() {
      return isCsmAddProduct() || isCsmCreateBasket();
    },
  },

  methods: {
    ...mapActions({
      GET_CITY: 'user/getCity',
      UPDATE_CITY: 'user/updateCity',
    }),

    changeCity(city) {
      this.$city.requestConfirmation({ city });
    }
  },

  serverPrefetch () {
    return this.GET_CITY();
  },
}
</script>

<style lang="scss">
.checkout-header {
  .main-bar {
    padding: 16px 0;
  }

  .container {
    align-items: center;
  }

  .city {
    position: relative;
    display: flex;
    margin-left: 33px;

    .current {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 16px;
      padding: 7px;
      cursor: pointer;

      svg {
        width: 16px;
        height: 16px;
        margin-left: 4px;
        color: $gray_lu;
      }
    }

    .search {
      position: absolute;
      top: 32px;
      left: -16px;

      .ui-dropdown-scrollview {
        overflow: auto;
        max-height: none;
      }

      .ui-dropdown-content {
        padding: 24px;
      }
    }
  }

  .phone {
    display: flex;
    align-items: center;
    margin-left: auto;
    flex-direction: column;
    font-family: Gilroy, sans-serif;
    text-align: end;

    & > a {
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
      color: $black;
      text-decoration: none;
    }

    & > span {
      display: none;
    }
  }

  .icons {
    margin-left: initial;
  }
}

@include breakpoint("desktop") {
  .checkout-header {
    .main-bar {
      padding: 16px 0 10px;
    }

    .phone,
    .icons {
      height: 46px;
    }

    .phone {
      display: block;

      & > a {
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
      }

      & > span {
        display: block;
        margin-top: 4px;
        font-size: 14px;
        line-height: 16px;
        color: $gray;
      }
    }

    .icons {
      align-items: center;

      .control-user {
        height: 46px;
        align-items: center;
      }

      .dropdown {
        top: 46px;
      }
    }
  }
}
</style>
